import { postJSON } from "../utils/http.js"

export function queryStoreLocatorFilter(param, options = {}) {
  return postJSON("/api/index/storeLocator/filter", { param }, { ...options, loading: true })
}
export function queryStoreLocator(param, options = {}) {
  return postJSON("/api/index/storeLocator/location", { param }, { ...options, loading: true })
}
